/**
 * Opens and closes the drop down navigation in the header.
 * @param {Event} e
 * @param {string} closeOtherSelector Optional selector for other menu parents to close.
 */
const toggleDesktopMegaMenu = function(e, closeOtherSelector) {
	e.preventDefault();
	let el = e.target;
	let addClass = function (el, className) {
		if (el.classList) {
			el.classList.add(className);
		} else {
			el.className += ' ' + className;
		}
	};
	let hasClass = function (el, className) {
		if (el.classList) {
			return el.classList.contains(className);
		} else {
			return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
		}
	};
	let removeClass = function (el, className) {
		if (el.classList) {
			el.classList.remove(className);
		} else {
			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	};
	let toggleClass = function (el, className) {
		if (el.classList) {
			el.classList.toggle(className);
		} else {
			let classes = el.className.split(' ');
			let existingIndex = classes.indexOf(className);

			if (existingIndex >= 0) {
				classes.splice(existingIndex, 1);
			} else {
				classes.push(className);
			}

			el.className = classes.join(' ');
		}
	};

	Array.prototype.filter.call(el.parentNode.parentNode.children, function(child){
		if (child !== el.parentNode) {
			removeClass(child, 'active');
		}
	});

	if (closeOtherSelector && typeof closeOtherSelector === 'string') {
		document.querySelectorAll(closeOtherSelector).forEach(function (child) {
			if (child !== el.parentNode) {
				removeClass(child, 'active');
			}
		});
	}

	toggleClass(el.parentNode, 'active');

	document.querySelectorAll('.mega-menu-parrent > .close-nav-btn').forEach(function (el) {
		el.parentNode.removeChild(el);
	});

	if (hasClass(el.parentNode, 'active')) {
		addClass(document.getElementById('black-overlay'), 'active-body-cover');
		let div = document.createElement('div');
		div.innerHTML = 'X';
		addClass(div, 'close-nav-btn');
		el.parentNode.querySelector('.mega-menu-parrent').appendChild(div);
	} else {
		removeClass(document.getElementById('black-overlay'), 'active-body-cover');
	}
};

export default toggleDesktopMegaMenu;
